import { buildAssessmentStatusFilterOptions } from "./assessmentStatuses";

/** Admin calendar default: every workflow status except Archived (prototype parity). */
export function buildDefaultAdminCalendarStatusFilters() {
  return buildAssessmentStatusFilterOptions()
    .map((option) => option.statusID)
    .filter((statusId) => statusId !== "Archived");
}

export function resolveCalendarStatusForApi(selectedFilters = {}, isAdmin = false) {
  const selected = (selectedFilters.Status || []).filter(Boolean);
  if (selected.length) return selected;
  if (isAdmin) return buildDefaultAdminCalendarStatusFilters();
  return [];
}
